/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TraceRecordSeverity {
    Low = 0,
    Medium = 1,
    High = 2,
}
